import { RootState } from '../../store';

export const getManualVerificationDynamicURLValues = (state: RootState) =>
  state.manualVerificationTemporaryDetails.dynamicURLValues;
export const getManualVerificationDynamicBodyValues = (state: RootState) =>
  state.manualVerificationTemporaryDetails.dynamicBodyValues;
